import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

import { FieldHint, Input } from '@atlas/ui';

import Field from 'common/Form/Field';
import useNumberFieldBase from 'common/Form/Fields/useNumberFieldBase';

const NumberFieldBase = ({
  field,
  numberFormatProps,
  onBlur,
  onChange,
  onFocus,
  valueTransformer,
}) => {
  const {
    changeHandler,
    handleBeforeInput,
    handleKeyDown,
    handleMaskChange,
    hint,
    isDisabled,
    maskOption,
    maskedValue,
    placeholder,
    sharedProps,
    value,
  } = useNumberFieldBase({ field, onBlur, onChange, onFocus, valueTransformer });

  if (maskOption) {
    return (
      <Field options={field}>
        <Input
          {...sharedProps}
          onBeforeInput={handleBeforeInput}
          onChange={handleMaskChange}
          onKeyDown={handleKeyDown}
          placeholder={maskOption}
          value={maskedValue}
        />
        {!isDisabled && <FieldHint hint={hint} showOnClick />}
      </Field>
    );
  }

  return (
    <Field options={field}>
      <NumberFormat
        {...sharedProps}
        {...numberFormatProps}
        customInput={Input}
        onChange={changeHandler}
        placeholder={placeholder}
        value={value}
      />
      {!isDisabled && <FieldHint hint={hint} showOnClick />}
    </Field>
  );
};

NumberFieldBase.propTypes = {
  field: PropTypes.object.isRequired,
  numberFormatProps: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  valueTransformer: PropTypes.func.isRequired,
};

export default NumberFieldBase;
